export class Colors {
    static WHITE = '#fff';
    static BLACK = '#000';
    static DODGER_BLUE = '#337DFF';
}
